import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent, BOOKING_SCREENING_URL } from '../lib/tracking';

export default function NotFound() {
  const problemLinks = [
    { title: 'Stress', href: '/stress/' },
    { title: 'Angst', href: '/angst/' },
    { title: 'Depression', href: '/depression/' },
    { title: 'Lavt selvværd', href: '/lavt-selvvaerd/' },
    { title: 'Traumer', href: '/traumer/' },
    { title: 'Sorg & krise', href: '/sorg-og-krise/' },
    { title: 'Vaner & hypnose', href: '/hypnose-vaner/' },
  ];

  return (
    <div className="bg-[#ECEEF1] py-20 sm:py-28 text-center">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="text-xs uppercase tracking-widest font-semibold text-[#5A232E] block mb-2">
          Fejl 404
        </span>
        <h1 className="font-display text-4xl sm:text-5xl text-[#5A232E] mb-4">
          Siden blev desværre ikke fundet
        </h1>
        <p className="text-sm sm:text-base text-[#6c7480] max-w-lg mx-auto mb-8 leading-relaxed">
          Adressen du har indtastet findes ikke, eller siden er blevet flyttet i forbindelse med vores nye hjemmeside.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mb-16">
          <Link
            to="/"
            className="px-6 py-3 rounded-xl bg-[#5A232E] text-white font-medium text-sm hover:bg-[#431722] transition-colors"
          >
            Gå til forsiden
          </Link>
          <a
            href={BOOKING_SCREENING_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('cta_booking_click', { location: '404_page' })}
            className="px-6 py-3 rounded-xl bg-[#5A232E] text-white font-semibold text-sm hover:bg-[#431722] transition-colors"
          >
            Book gratis samtale
          </a>
        </div>

        {/* Hvad vil du gerne have hjælp til? */}
        <div className="bg-white p-8 rounded-3xl border border-[#D9DDE2] shadow-xs text-left max-w-2xl mx-auto">
          <h2 className="font-display text-xl text-[#5A232E] mb-2 text-center">
            Hvad vil du gerne have hjælp til?
          </h2>
          <p className="text-xs text-[#6c7480] text-center mb-6">
            Find direkte vej til det tema, der fylder for dig:
          </p>
          <div className="flex flex-wrap justify-center gap-2.5">
            {problemLinks.map((p, i) => (
              <Link
                key={i}
                to={p.href}
                className="text-xs font-medium px-4 py-2 rounded-xl bg-[#ECEEF1] text-[#5A232E] hover:bg-[#D9DDE2] border border-[#D9DDE2] transition-colors"
              >
                {p.title} →
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
